const styles = {
        body: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            lineHeight: '1.6',
            color: '#333',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: '#f9f9f9',
        },
        policyContainer: {
            backgroundColor: '#ffffff',
            padding: '40px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            maxWidth: '800px',
            justifySelf: 'center',
        },
        h1: {
            color: '#2c3e50',
            borderBottom: '2px solid #eaeaea',
            paddingBottom: '10px',
            fontSize: '1.8em',
        },
        h2: {
            color: '#2c3e50',
            marginTop: '30px',
            fontSize: '1.4em',
        },
        h3: {
            color: '#444',
            fontSize: '1.1em',
            marginTop: '20px',
            marginBottom: '10px',
        },
        ul: {
            paddingLeft: '20px',
        },
        li: {
            marginBottom: '8px',
        },
        lastUpdated: {
            color: '#777',
            fontStyle: 'italic',
            marginBottom: '30px',
        },
        contactBox: {
            backgroundColor: '#f0f4f8',
            padding: '20px',
            borderLeft: '4px solid #2c3e50',
            marginTop: '20px',
        },
        link: {
            color: '#0066cc',
            textDecoration: 'none',
        },
    };

    export default styles;